var cov_22czcmskfj = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Menu/styles/index.js",
      hash = "176ec7bb4d9a48f266247fcce1f7d114017772b2",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Menu/styles/index.js",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 25
        },
        end: {
          line: 5,
          column: 53
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var menuLess = {};
import genaration from '../../utils/classname';
export var menuClass = (cov_22czcmskfj.s[0]++, genaration(menuLess, 'menu'));